import React, { memo, Suspense } from 'react'

import Hero from '@/components/Hero/Hero'
import Features from '@/components/Features/Features'
import PropertyShowcase from '@/components/PropertyShowcase/PropertyShowcase'
import GetInTouch from '@/components/GetInTouch/GetInTouch'
import Footer from '@/components/Footer/Footer'
import CompanyOverview from '@/components/Company/CompanyOverview'
import Navigation from '@/components/Navigation/Navigation'

interface Props {}

const Index: React.FC<Props> = memo(() => {
  return (
    <>
      <Hero />
      <CompanyOverview />
      <Features />
      <PropertyShowcase />
      <GetInTouch />
    </>
  )
})
Index.displayName = 'Index'

export default Index
